import { makeObservable, action, observable } from 'mobx';
import { BaseService } from '../base';
import { UpcomingResponseModel, UpcomingListModel } from './model';
import Upcoming from './interface';

export class CommonService extends BaseService {
  @observable loaded: boolean = true;
  @observable hasMore: boolean = true;
  /** 拉取失败(code!==0)。用来区分「加载成功但没有订单」和「加载失败」——否则页面只能靠 dataList 为空瞎猜 */
  @observable loadFailed: boolean = false;
  @observable upcomingState: UpcomingResponseModel = new UpcomingResponseModel();

  @observable dataList: UpcomingListModel[] = [];

  protected page_index = 0;
  protected page_size = 10;

  constructor() {
    super();
    makeObservable(this);
  }

  @action
  initInfo() {
    this.loaded = true;
    this.hasMore = true;
    this.loadFailed = false;
    this.page_index = 0;
    this.page_size = 10;
    this.dataList = [];
    // header 的金额/订单额/放款比例/放款时间都取自 upcomingState，切 Tab、离开页面时必须一并重置。
    // 否则新 Tab 在响应返回前(以及请求失败、fetchInfo 不写 upcomingState 时)会一直显示上一个 Tab 的数字。
    this.upcomingState = new UpcomingResponseModel();
  }

  @action
  async fetchInfo() {
    // 如果已经标记当前状态为hasmore：false
    if (!this.hasMore || !this.loaded) return;
    this.loaded = false;
    this.loadFailed = false;

    const { code, result } = await this.post(Upcoming.API.get_user_candidate_orders_summary, {
      body: {
        pagination: {
          page_index: this.page_index + 1,
          page_size: this.page_size,
          cursor:
            this.dataList.length > 0
              ? this.dataList?.[this.dataList.length - 1]?.fast_escrow_id ?? 0
              : 0,
        },
      },
    });
    if (code === 0) {
      const { page_info, list = [], ...info } = result;

      this.dataList = (list ?? []).map((item: UpcomingListModel) => {
        // refactor后接口fast_escrow_id改为id
        item.fast_escrow_id = item.fast_escrow_id || item.id;
        return item;
      });
      this.hasMore = page_info.has_more;
      this.page_index = page_info.page_index;
      this.upcomingState = {
        ...this.upcomingState,
        ...result,
      };
      this.loaded = true;
      return result;
    }
    this.loaded = true;
    this.hasMore = false;
    this.loadFailed = true;
  }
}
